import { render } from "./OldGamesButton.vue?vue&type=template&id=b4f7fd28&scoped=true"
import script from "./OldGamesButton.vue?vue&type=script&lang=js"
export * from "./OldGamesButton.vue?vue&type=script&lang=js"

import "./OldGamesButton.vue?vue&type=style&index=0&id=b4f7fd28&scoped=true&lang=css"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f7fd28"]])

export default __exports__